// Scrollbar for Embla slider.
const setupScrollBar = (emblaApi, scrollNode) => {
  // Handle thumb drag events
  let isDragging = false;

  // Update carousel scroll when scrollbar thumb is dragged
  const dragThumb = (event) => {
    if (!isDragging) return;

    // Get track sizes.
    const trackRect = scrollNode.parentNode.getBoundingClientRect();

    // Calculate the distance from the left edge of the track to the pointer.
    const pointerOffset = event.clientX - trackRect.left;

    // Calculate the position of the thumb relative to the track.
    const thumbPosition = pointerOffset / trackRect.width;

    // Calculate the number of scroll snaps.
    const snapCount = emblaApi.scrollSnapList().length;

    // Calculate the index of the snap that the thumb corresponds to.
    const scrollToIndex = Math.round(thumbPosition * (snapCount - 1)); // Subtract 1 to prevent overshooting

    // Scroll to the corresponding snap index
    emblaApi.scrollTo(scrollToIndex);
  };

  scrollNode.addEventListener('pointerdown', () => {
    isDragging = true;
    document.addEventListener('pointermove', dragThumb);
  });

  document.addEventListener('pointerup', () => {
    if (isDragging) isDragging = false;
    document.removeEventListener('pointermove', dragThumb);
  });

  const setScrollbarSize = () => {
    const { length } = emblaApi.slideNodes();
    const { length: snapListLength } = emblaApi.scrollSnapList();
    const ratio =
      100 -
      ((snapListLength === length ? snapListLength - 1 : snapListLength) /
        length) *
        100;
    scrollNode.style.setProperty('--scrollbar-width', `${ratio}%`);
  };

  const applyProgress = () => {
    const { clientWidth } = scrollNode;
    const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress())) * 100;
    const widthAdjustment = Math.min(
      clientWidth,
      (progress * clientWidth) / 100,
    );
    scrollNode.style.marginLeft = `calc(${progress}% - ${widthAdjustment}px)`;
  };

  const removeProgress = () => {
    scrollNode.style.removeProperty('style');
  };

  return { applyProgress, removeProgress, setScrollbarSize };
};

export default setupScrollBar;
